import type { FC, ReactNode } from 'react'
import type { GetStaticProps } from 'next'
import type { Project } from '@/types'

import { Seo } from '@/components/generals/seo'
import { Layout } from '@/components/generals/layout'
import { PageHero } from '@/components/sections/page-hero'
import { WorkGallery } from '@/components/sections/work-gallery'
import { Testimonials } from '@/components/sections/testimonials'
import { Cta } from '@/components/sections/cta'
import { getProjects } from '@/lib/content'

type WorkProps = {
    projects: Project[]
}

const Work: FC<WorkProps> = ({ projects }): ReactNode => {
    return (
        <Layout>
            <Seo
                title='Project gallery'
                description='Browse completed NG Painting Pro projects across Massachusetts: exterior repaints, kitchen and bathroom cabinet painting, and commercial building work.'
            />

            <PageHero
                title='Project gallery'
                subtitle='Browse our completed painting projects. Every photo reflects our focus on quality work and careful attention to detail.'
                subtitleModifier='about'
            />

            <WorkGallery projects={projects} />

            <Testimonials />
            <Cta />
        </Layout>
    )
}

export const getStaticProps: GetStaticProps<WorkProps> = async () => {
    const projects = await getProjects()

    return {
        props: { projects },
        revalidate: 60
    }
}

export default Work
